(function () {
  var STORAGE_KEY = 'petworld_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* private browsing / storage disabled - fail silently */
    }
  }

  function findIndexById(items, id) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === id) return i;
    }
    return -1;
  }

  function syncAllButtons() {
    var items = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = String(btn.getAttribute('data-product-id'));
      btn.setAttribute('aria-pressed', findIndexById(items, id) !== -1 ? 'true' : 'false');
    });
  }

  function cardHtml(item) {
    return (
      '<div class="wishlist-page__card">' +
        '<a href="' + item.url + '" class="wishlist-page__card-img">' +
          (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<a href="' + item.url + '" class="wishlist-page__card-name">' + item.title + '</a>' +
        '<div class="wishlist-page__card-price">' + item.price + '</div>' +
        '<div class="wishlist-page__card-actions">' +
          '<button type="button" class="wishlist-page__add-btn" data-add-to-cart data-variant-id="' + item.variantId + '">Add</button>' +
          '<button type="button" class="wishlist-page__remove-btn" data-wishlist-toggle data-product-id="' + item.id + '" aria-label="Remove from wishlist">Remove</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return; // not on the wishlist page - nothing to do

    var empty = document.querySelector('[data-wishlist-empty]');
    var items = getWishlist();

    if (items.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(cardHtml).join('');
  }

  function toggleItem(btn) {
    var id = String(btn.getAttribute('data-product-id'));
    var items = getWishlist();
    var index = findIndexById(items, id);

    if (index !== -1) {
      items.splice(index, 1);
    } else {
      items.push({
        id: id,
        title: btn.getAttribute('data-product-title') || '',
        url: btn.getAttribute('data-product-url') || '#',
        image: btn.getAttribute('data-product-image') || '',
        price: btn.getAttribute('data-product-price') || '',
        variantId: btn.getAttribute('data-variant-id') || ''
      });
    }

    saveWishlist(items);
    syncAllButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggleItem(btn);
  });

  function init() {
    syncAllButtons();
    renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
})();